import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import reducerGenerator from '../hierarchyAssignmentsEditor/reducerGenerator'
import {CLOSE_ALL_PANELS} from '../common/actionTypes'

const hierarchyAssignmentsEditorReducer = reducerGenerator({
    actionTypes: ActionTypes
})

const initialState = {
    ...hierarchyAssignmentsEditorReducer.initialState,
    show: false,
    onlyActiveEntities: false
}

const createManagementAssignmentsEditor = handleActions({
    ...hierarchyAssignmentsEditorReducer.handlers,
    [ActionTypes.SHOW_SET]: (state, {payload: show}) => ({
        ...state,
        show
    }),
    [ActionTypes.ONLY_ACTIVE_ENTITIES_SET]: (state, {payload: onlyActiveEntities}) => ({
        ...state,
        onlyActiveEntities
    }),
    [CLOSE_ALL_PANELS]: (state) => ({
        ...state,
        show: false,
        loading: false,
        loaded: false,
        customersLoaded: false,
        projectsLoaded: false,
        tasksLoaded: false,
        editingUserId: null,
        editingLevel: {
            customerId: null,
            projectId: null,
        },
        customerIdsOrder: [],
        projectIdsOrder: [],
        taskIdsOrder: [],
        canManageParentCustomer: false,
        canManageParentProject: false,
        canWorkCustomerIds: {},
        canManageCustomerIds: {},
        canWorkProjectIds: {},
        canManageProjectIds: {},
        canWorkTaskIds: {},
        canManageTaskIds: {},
        projectCountsByCustomers: {},
        taskCountsByCustomers: {},
        taskCountsByProjects: {},
        futureCustomersAssigned: false,
        someCustomersOrLowerAssigned: false,
        allCustomersAssigned: false,
        futureProjectsAssigned: false,
        someProjectsOrLowerAssigned: false,
        allProjectsAssigned: false,
        futureTasksAssigned: false,
        someTasksAssigned: false,
        allTasksAssigned: false,
        changingCustomerAssignments: {},
        changingProjectAssignments: {},
        changingTaskAssignments: {},
        customersSearchOpen: false,
        customersSearchText: '',
        projectsSearchOpen: false,
        projectsSearchText: '',
        tasksSearchOpen: false,
        tasksSearchText: '',
        changingAllAssignments: false,
        viewerCanManageCustomerIds: {},
        viewerCanManageProjectIds: {},
    }),
}, initialState)
export default createManagementAssignmentsEditor


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/createUserManagementAssignmentsEditor/reducer.js